var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "approval-card",
    on: {
      click: function click($event) {
        return _vm.$emit("click", _vm.normalizedCard);
      }
    }
  }, [_c("div", {
    staticClass: "card-header"
  }, [_vm._m(0), _c("div", {
    staticClass: "card-header-main"
  }, [_c("span", {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.normalizedCard.title || "审批"))]), _c("span", {
    staticClass: "card-subtitle"
  }, [_vm._v("审批助手")])]), _c("span", {
    staticClass: "status-chip",
    class: "status-chip--".concat(_vm.statusTagType)
  }, [_vm._v(_vm._s(_vm.statusText))])]), _c("div", {
    staticClass: "card-body"
  }, [_c("p", {
    staticClass: "card-summary"
  }, [_vm._v(_vm._s(_vm.normalizedCard.summary || _vm.normalizedCard.extra.actionText || ""))]), _c("div", {
    staticClass: "card-meta"
  }, [_vm.normalizedCard.extra.initiatorName ? _c("p", {
    staticClass: "card-info"
  }, [_c("span", {
    staticClass: "meta-label"
  }, [_vm._v("发起人")]), _c("span", [_vm._v(_vm._s(_vm.normalizedCard.extra.initiatorName))])]) : _vm._e(), _vm.normalizedCard.extra.currentHandler ? _c("p", {
    staticClass: "card-info"
  }, [_c("span", {
    staticClass: "meta-label"
  }, [_vm._v("当前处理人")]), _c("span", [_vm._v(_vm._s(_vm.normalizedCard.extra.currentHandler))])]) : _vm._e(), _vm.normalizedCard.extra.createdTime ? _c("p", {
    staticClass: "card-info"
  }, [_c("span", {
    staticClass: "meta-label"
  }, [_vm._v("时间")]), _c("span", [_vm._v(_vm._s(_vm.formatTime(_vm.normalizedCard.extra.createdTime)))])]) : _vm._e()])]), _c("div", {
    staticClass: "card-footer"
  }, [_c("span", [_vm._v(_vm._s(_vm.actionText))]), _c("i", {
    staticClass: "el-icon-arrow-right"
  })])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "card-icon-wrap"
  }, [_c("i", {
    staticClass: "el-icon-document"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };